import { render, staticRenderFns } from "./typeProductActions.vue?vue&type=template&id=55a658e2"
import script from "./typeProductActions.vue?vue&type=script&lang=js"
export * from "./typeProductActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports